<template>
  <div class="card-img cursor-pointer">
    <div class="wrapper" @click.prevent="find(item)" />
    <img
      v-if="item.type == 'img'"
      class="h-full w-full object-cover"
      :src="item.src"
      loading="lazy"
      data-src="@/assets/images/loading.gif"
      data-srcset="@/assets/images/loading.gif"
      alt=""
    />
    <img
      v-else
      class="h-full w-full object-cover"
      :src="item.srcImg"
      loading="lazy"
      data-src="@/assets/images/loading.gif"
      data-srcset="@/assets/images/loading.gif"
      alt=""
    />
    <!-- <video
      v-else
      class="w-full h-full"
      preload="auto"
      poster="@/assets/images/loading.gif"
      controls
      autoplay
      muted
      loop
      playsinline
    >
      <source :src="item.srcImg" type="video/mp4" />
    </video> -->
    <span class="number_ font-dinpro absolute leading-none text-xs p-1">
      {{ index }}
    </span>
    <button
      class="absolute z-10 right-0 leading-none text-2xl lg:text-3xl"
      @click.prevent="remove(index, item)"
      :disabled="isBusy"
    >
      <span class="icon-imgclose text-white opacity-90"></span>
    </button>
    <!-- <a
      class="icon-imgmove absolute inset-x-0 bottom-0 leading-none text-base pb-2 text-white cursor-pointer z-50"
    ></a> -->
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    find(item) {
      this.$emit("find", item);
    },
    remove(index, item) {
      this.$emit("remove", index, item);
    },
  },
};
</script>

<style labg="css">
.number_ {
  background-color: #23443d;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  width: 20px;
  border-bottom-right-radius: 4px;
}
</style>
